<div class="te-wrapper">

  <!-- ══ Toolbar ══════════════════════════════════════════════════════════════ -->
  <div class="te-toolbar">
    <div class="te-toolbar__left">
      <!-- Back -->
      <hub-button [size]="'lg'" [style]="'outline'"  [icon]="'arrow-left'" (buttonClick)="save(); cancel()">
      </hub-button>

      <!-- Template Name -->
      <input type="text" pInputText class="te-name-input" [(ngModel)]="template.name" [placeholder]="'bikeshop.receipt_template.editor.name_placeholder' | translate" (blur)="pushHistory()"/>

      <!-- Required by Date -->
      <input type="date" pInputText class="te-date-input" [(ngModel)]="template.requiredByDate" (blur)="pushHistory()"/>

      <!-- Type -->
      <!--<p-dropdown [options]="templateTypeOptions"
                  [(ngModel)]="template.type"
                  optionLabel="label"
                  optionValue="value"
                  [placeholder]="'bikeshop.receipt_template.editor.type_placeholder' | translate"
                  styleClass="te-type-dd">
      </p-dropdown>-->

      <!-- Page Size Preset -->
      <p-dropdown [options]="pageSizePresets"
                  [(ngModel)]="selectedPreset"
                  dataKey="name"
                  [placeholder]="'bikeshop.receipt_template.editor.page_size_placeholder' | translate"
                  (onChange)="onPresetChange($event.value)"
                  styleClass="te-preset-dd">
        <ng-template pTemplate="selectedItem" let-option>
          {{ option.translateKey | translate }}
        </ng-template>
        <ng-template pTemplate="item" let-option>
          {{ option.translateKey | translate }}
        </ng-template>
      </p-dropdown>

      <!-- Custom Dimensions (shown when Custom is selected) -->
      <ng-container *ngIf="selectedPreset?.widthMm === null">
        <span class="te-dim-label">{{ 'bikeshop.receipt_template.editor.dim_w' | translate }}</span>
        <input type="number" pInputText class="te-dim-input" [(ngModel)]="template.widthMm" min="10" max="900" />
        <span class="te-dim-label">{{ 'bikeshop.receipt_template.editor.dim_h' | translate }}</span>
        <input type="number" pInputText class="te-dim-input" [(ngModel)]="template.heightMm" min="10" max="900" />
        <span class="te-dim-label">{{ 'bikeshop.receipt_template.editor.dim_mm' | translate }}</span>
      </ng-container>

      <!-- Orientation -->
      <!--<div class="te-orientation">
        <button pButton icon="pi pi-align-justify"
                class="p-button-text te-orient-btn"
                [class.active]="template.orientation === 'portrait'"
                pTooltip="Portrait"
                (click)="onOrientationChange('portrait')">
        </button>
        <button pButton icon="pi pi-align-justify"
                class="p-button-text te-orient-btn te-orient-btn--land"
                [class.active]="template.orientation === 'landscape'"
                pTooltip="Landscape"
                (click)="onOrientationChange('landscape')">
        </button>
      </div>-->
    </div>

    <div class="te-toolbar__right">
      <!-- Grid toggle -->
      <!--<button pButton icon="pi pi-th-large" class="p-button-text te-btn-icon"
          [class.active]="showGrid"
          pTooltip="Toggle grid"
          (click)="showGrid = !showGrid">
  </button>-->

      <hub-button [size]="'lg'" [style]="'outline'" [icon]="'grid-plus'" [class.active]="showGrid" (buttonClick)="showGrid = !showGrid">
      </hub-button>

      <!-- Zoom -->
      <div class="te-zoom">
        <!--<button pButton icon="pi pi-minus" class="p-button-text p-button-sm" [disabled]="zoom <= 25" (click)="zoom = zoom - 25"></button>-->
        <hub-button [size]="'lg'" [style]="'outline'" [icon]="'minus'" [disabled]="zoom <= 25" (buttonClick)="zoom = zoom - 25">
        </hub-button>
        <span class="te-zoom-label">{{ zoom }}%</span>
        <!--<button pButton icon="pi pi-plus" class="p-button-text p-button-sm" [disabled]="zoom >= 200" (click)="zoom = zoom + 25"></button>-->
        <hub-button [size]="'lg'" [style]="'outline'" [icon]="'plus-alt'" [disabled]="zoom >= 200" (buttonClick)="zoom = zoom + 25">
        </hub-button>
      </div>

      <!-- Preview -->
      <div class="te-preview-toggle">
        <!--<span class="te-preview-label">Live Preview</span>
        <p-inputSwitch [(ngModel)]="previewMode" pTooltip="Toggle live data preview"></p-inputSwitch>-->
        <hub-button [size]="'lg'" [style]="'outline'" [icon]="'eye'" (buttonClick)="previewMode = !previewMode"></hub-button>
      </div>

      <!-- Undo / Redo -->
      <!--<button pButton icon="pi pi-undo" class="p-button-text te-btn-icon" pTooltip="Undo (Ctrl+Z)" [disabled]="!canUndo" (click)="undo()"></button>
      <button pButton icon="pi pi-refresh" class="p-button-text te-btn-icon" pTooltip="Redo (Ctrl+Y)" [disabled]="!canRedo" (click)="redo()"></button>-->

      <hub-button [size]="'lg'" [style]="'outline'" [icon]="'undo'" [disabled]="!canUndo" (click)="undo()">
      </hub-button>
      <hub-button [size]="'lg'" [style]="'outline'" [icon]="'redo'" [disabled]="!canRedo" (click)="redo()">
      </hub-button>

      <span class="te-toolbar-divider"></span>

      <!-- Job Card ID — test-print data ──────────────────────────────── -->
      <!--<div class="te-test-data-group" pTooltip="Load a real job card to preview merge-tag values on the canvas">
        <input type="text"
               pInputText
               class="te-test-jcid-input"
               placeholder="Job ID for test print"
               [(ngModel)]="testJobCardId"
               (keydown.enter)="loadTestJobData()" />
        <button pButton
                [icon]="isLoadingTestData ? 'pi pi-spin pi-spinner' : 'pi pi-cloud-download'"
                class="p-button-text p-button-sm te-btn-icon"
                [disabled]="!testJobCardId || isLoadingTestData"
                pTooltip="Load job card data onto canvas"
                (click)="loadTestJobData()">
        </button>
        <ng-container *ngIf="liveJobData && !isLoadingTestData">
          <i class="pi pi-check-circle te-test-data-loaded-icon"
             pTooltip="Real job data loaded — canvas shows live values">
          </i>
          <button pButton icon="pi pi-times"
                  class="p-button-text p-button-sm te-btn-icon te-btn-clear"
                  pTooltip="Clear test data"
                  (click)="clearTestJobData()">
          </button>
        </ng-container>
      </div>-->

      <!-- Test Print -->
      <!--<button pButton icon="pi pi-print" class="p-button-text te-btn-icon" pTooltip="Test print (prints canvas at 100% zoom)" (click)="testPrint()"></button>-->
      <hub-button [size]="'lg'" [style]="'outline'" [icon]="'print'" (buttonClick)="testPrint()">
      </hub-button>
      <!-- Save -->
      <!--<button pButton label="Save" icon="pi pi-save" class="p-button-primary te-btn-save" [disabled]="saving" (click)="save()">
    <i class="pi pi-spin pi-spinner" *ngIf="saving"></i>
  </button>-->
      <!-- Active toggle -->
      <!--<div class="te-active-toggle" pTooltip="Only one template per type can be active at a time.">
        <span class="te-active-label">{{ template.isActive ? 'Active' : 'Draft' }}</span>
        <p-inputSwitch
          [ngModel]="template.isActive"
          (onChange)="onActiveToggleChange($event)">
        </p-inputSwitch>
      </div>-->

      <hub-button [size]="'lg'" [style]="'outline'" [icon]="'save'" (buttonClick)="save()">
      </hub-button>
    </div>
  </div>

  <!-- ══ Editor Body ═══════════════════════════════════════════════════════════ -->
  <div class="te-body">

    <!-- Left: Merge Tags Panel -->
    <div class="te-panel-left">
      <app-merge-tags-panel
        [placedTagKeys]="placedTagKeys"
        [previewMode]="previewMode"
        (tagDropped)="onTagAddedFromPanel($event)"
        (addFreeText)="addFreeText()"
        (addDivider)="addDivider()">
      </app-merge-tags-panel>
    </div>

    <!-- Center: Canvas -->
    <div class="te-canvas-area">
      <app-template-canvas
        [template]="template"
        [selectedElements]="selectedElements"
        [previewMode]="previewMode"
        [customData]="effectiveCustomData"
        [zoom]="zoom"
        [showGrid]="showGrid"
        (elementSelected)="onElementSelected($event)"
        (groupMoved)="onGroupMoved($event)"
        (groupMoveEnded)="onGroupMoveEnded($event)"
        (multiSelected)="onMultiSelected($event)"
        (elementMoved)="onElementMoved($event)"
        (elementMoveEnded)="onElementMoveEnded($event)"
        (elementRemoved)="removeElement($event)"
        (elementContentChanged)="onElementContentChanged($event)"
        (tagDropped)="onTagDroppedOnCanvas($event)">
      </app-template-canvas>
    </div>

    <!-- Right: Properties Panel -->
    <div class="te-panel-right" [class.te-panel-right--visible]="selectedElements.length > 0">

      <!-- Single element selected: show full properties panel -->
      <app-element-properties
        *ngIf="selectedElements.length === 1"
        [element]="selectedElements[0]"
        [canvasWith]="template.widthMm"
        [canvasHeight]="template.heightMm"
        (elementChanged)="onElementChanged($event)"
        (elementRemoved)="removeElement($event)"
        (bringForward)="bringForward($event)"
        (sendBackward)="sendBackward($event)">
      </app-element-properties>

      <!-- Multiple elements selected: show count + group-delete -->
      <div class="te-multi-select-info" *ngIf="selectedElements.length > 1">
        <i class="pi pi-objects-column"></i>
        <p>{{ 'bikeshop.receipt_template.editor.multi_selected' | translate:{ count: selectedElements.length } }}</p>
        <button pButton [label]="'bikeshop.receipt_template.editor.delete_all' | translate" icon="pi pi-trash"
                class="p-button-danger p-button-outlined p-button-sm te-btn-delete-group"
                (click)="removeSelectedElements()">
        </button>
      </div>

      <!-- Nothing selected -->
      <div class="te-no-selection" *ngIf="selectedElements.length === 0">
        <i class="pi pi-mouse"></i>
        <p>{{ 'bikeshop.receipt_template.editor.no_selection' | translate }}</p>
      </div>
    </div>

  </div>

</div>

<p-toast position="bottom-right"></p-toast>
